import React, { useEffect, useState } from "react";
import { useFirestoreConnect, isLoaded, isEmpty } from "react-redux-firebase";
import { useSelector, connect } from "react-redux";
import LoadingIndicator from "../common/LoadingIndicator";

import Select from "react-select";
import { setOrderDriver } from "../../store/actions/RestaurantActions";

const DriverSelector = ({
  selected,
  restaurantId,
  orderId,
  selectDriver,
  userId,
}) => {
  const [selectedValue, setSelectedValue] = useState(selected);

  const select = (obj) => {
    setSelectedValue(obj.value);

    selectDriver(restaurantId, obj.value, orderId, userId);
  };

  useFirestoreConnect([
    {
      collection: "restaurants",
      doc: restaurantId || "nothing",
      subcollections: [{ collection: "drivers" }],
      storeAs: `${restaurantId}-drivers`,
    },
  ]);

  const drivers = useSelector(({ firestore }) => {
    return firestore.ordered[`${restaurantId}-drivers`]
      ? firestore.ordered[`${restaurantId}-drivers`].map((driver) => {
          return { value: driver.id, label: driver.name };
        })
      : [];
  });

  if (!isLoaded(drivers)) return <LoadingIndicator />;

  return (
    <Select
      options={drivers}
      value={drivers.filter((option) => option.value === selectedValue)}
      onChange={select}
      placeholder="Asigna un repartidor a la orden"
    />
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    selectDriver: (restaurantId, driverId, orderId, userId) =>
      dispatch(setOrderDriver(restaurantId, driverId, orderId, userId)),
  };
};

export default connect(null, mapDispatchToProps)(DriverSelector);
